import { TextField, NumberInput } from "react-admin";

import BusinessIcon from "@mui/icons-material/Business";
import { MyList } from "../../ra-lb-tools/components/myList";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../../ra-lb-tools/components/myReference";
import { UserField, UserInput } from "../users";
import { RecordSummary, MyShow } from "../../ra-lb-tools/components/MyShow";
import {
  MyTabbedShowLayout,
  Tab,
} from "../../ra-lb-tools/components/myTabbedShowLayout";
import { LabeledColumn } from "../../ra-lb-tools/components/labeledColumn";
import { ReferenceInputString } from "../../ra-lb-tools/components/referenceInputString";
import { LockersStatusField } from "../lockers";
import { ClientField } from "../clients";
import { MyDateField } from "../../ra-lb-tools/components/myDateField";

export const SystemIcon = BusinessIcon;

export const LockerUsageEventList = (props) => {
  const filters = [
    <NumberInput source="lockerId" alwaysOn key={1} label="Locker Id" />,
    <UserInput source="userId" alwaysOn key={2} />,
    <ReferenceInputString
      source="type"
      reference="locker-usage-event-types"
      alwaysOn
      key={3}
    />,
    <ReferenceInputString
      source="source"
      reference="locker-usage-event-sources"
      alwaysOn
      key={4}
    />,
    <MyReferenceInput
      label="To Status"
      source="toStatus"
      reference="locker-statuses"
      alwaysOn
      key={5}
    />,
  ];

  const title = "Locker Usage Event";
  const resource = "locker-usage-events";

  return (
    <MyList
      title={title}
      resource={resource}
      sort={{
        field: "id",
        order: "DESC",
      }}
      filters={filters}
      {...props}
    >
      <TextField source="id" />
      <MyDateField source="timestamp" showTime />
      <MyReferenceField source="lockerId" reference="lockers" />
      <UserField source="userId" />
      <TextField source="type" />
      <TextField source="source" />
      <TextField source="keypadCode" />
      <ClientField source="clientExternalId" label="Client" sortable={false} />
      <LockersStatusField
        label="To Status"
        source="toStatus"
        statusIdField="toStatus"
        editable={false}
      />
      <MyReferenceField
        source="reservationId"
        reference="reservations"
        primaryField="id"
      />
      <MyReferenceField
        source="lockerUsageId"
        reference="locker-usage"
        primaryField="id"
      />
      <MyReferenceField
        source="lockerOpenRequestId"
        reference="locker-open-requests"
        primaryField="id"
      />
      <MyReferenceField
        source="openLockerTokenId"
        reference="open-locker-tokens"
        primaryField="id"
      />
      <MyDateField source="createdAt" showTime />
    </MyList>
  );
};

export const LockerUsageEventShow = () => {
  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <MyDateField source="timestamp" showTime />
              <MyReferenceField source="lockerId" reference="lockers" />
              <UserField source="userId" />
              <TextField source="type" />
              <TextField source="source" />
              <TextField source="keypadCode" />
            </LabeledColumn>
            <LabeledColumn>
              <ClientField source="clientExternalId" label="Client" />
              <LockersStatusField
                label="To Status"
                source="toStatus"
                statusIdField="toStatus"
                editable={false}
              />
              <MyReferenceField
                source="reservationId"
                reference="reservations"
                primaryField="id"
              />
              <MyReferenceField
                source="lockerUsageId"
                reference="locker-usage"
                primaryField="id"
              />
              <MyReferenceField
                source="lockerOpenRequestId"
                reference="locker-open-requests"
                primaryField="id"
              />
              <MyReferenceField
                source="openLockerTokenId"
                reference="open-locker-tokens"
                primaryField="id"
              />
              <MyDateField source="createdAt" showTime />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};
